import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import { ListItemText } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Arbitrator from "../../components/Arbitrator";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import UploadDocSingleFile from "../../components/UploadDocSingleFile";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import CardActions from "@material-ui/core/CardActions";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
  root:{
    display: "flex",
    flexDirection: "column",
    alignItem: "center",
    // marginTop:'600px',
    // '@media (max-width: 576px)': {
    //   marginTop:'10px',
    // }
  },
  formControl: {
    margin: theme.spacing.unit * 1,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    margin: theme.spacing.unit * 3,
  },
  button: {
    // display:'flex',
    //justifyContent: 'center',
    // margin: '0 Auto',
  },
});

class UploadDocsSingleFile extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    totaluploadFiles: 1,
    files: [],
    reset: false,
    uniqueId: localStorage.getItem("token"),
    uploading: false,
    uploadingFullPdf: false,
    typeOfAccount: localStorage.getItem("typeOfAccount"),
    userType:
      localStorage.getItem("typeOfAccount") == "arbitrator"
        ? "arbitrator"
        : localStorage.getItem("typeOfAccount") == "admin"
        ? "admin"
        : this.props.claimantUniqueId == localStorage.getItem("token")
        ? "claimant"
        : this.props.respondentUniqueId == localStorage.getItem("token")
        ? "respondent"
        : null,
    scheduledAwardDate: null,
    scheduledDateInput: "",
    scheduledAIGenDate: null,
    scheduledAIGenInput: "",
    scheduledNoticeAIGenDate: null,
    scheduledNoticeAIGenInput: "",
  };

  componentDidMount() {
    // Load scheduled date from caseData if it exists
    if (this.props.caseData && this.props.caseData.scheduledAwardDeliveryDate) {
      this.setState({
        scheduledDateInput: this.props.caseData.scheduledAwardDeliveryDate,
        scheduledAwardDate: this.props.caseData.scheduledAwardDeliveryDate
      });
    }
    
    // Load scheduled AI generation date from caseData if it exists
    if (this.props.caseData && this.props.caseData.scheduledAIGenDateTime) {
      this.setState({
        scheduledAIGenInput: this.props.caseData.scheduledAIGenDateTime,
        scheduledAIGenDate: this.props.caseData.scheduledAIGenDateTime
      });
    }
    
    // Load scheduled notice AI generation date from caseData if it exists
    if (this.props.caseData && this.props.caseData.scheduledNoticeAIGenDateTime) {
      this.setState({
        scheduledNoticeAIGenInput: this.props.caseData.scheduledNoticeAIGenDateTime,
        scheduledNoticeAIGenDate: this.props.caseData.scheduledNoticeAIGenDateTime
      });
    }
  }

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleOnAddIcon = () => {
    this.setState((state) => ({
      totaluploadFiles: state.totaluploadFiles + 1,
    }));
  };

  handleAddFile = (file, doc_name) => {
    this.props.addFile(file, doc_name);
  };

  handleResetFile = (filename) => {
    this.props.removeFile(filename);
  };
  handleResetAll = () => {
    this.setState({
      totaluploadFiles: 1,
      files: [],
      reset: false,
    });
  };

  submitHandler = () => {
    this.setState({ uploading: true });
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }
    this.props.uploadDocs(
      this.props.files,
      this.props.caseData.conversationId,
      this.props.caseId,
      userType,
      this.props.doc_type
    );
    this.handleResetAll();
  };

  submitHandlerUploadFullPdf = () => {
    this.setState({ uploadingFullPdf: true });
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }
    this.props.uploadFullPDFDoc(
      this.props.files,
      this.props.caseData.conversationId,
      this.props.caseId,
      userType,
      this.props.doc_type
    );
    this.handleResetAll();
  };

  toggleReset = () => {
    this.setState((prevState) => ({
      reset: !prevState.reset,
    }));
  };

  handleScheduledDateChange = (event) => {
    this.setState({ scheduledDateInput: event.target.value });
  };

  handleScheduledAIGenChange = (event) => {
    this.setState({ scheduledAIGenInput: event.target.value });
  };

  handleScheduledNoticeAIGenChange = (event) => {
    this.setState({ scheduledNoticeAIGenInput: event.target.value });
  };

  handleScheduleAwardDate = async () => {
    if (this.state.scheduledDateInput) {
      try {
        this.setState({ uploading: true });
        
        const response = await fetch('https://www.hkarbsoc.org.hk:9000/scheduleAwardDelivery', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            caseId: this.props.caseId,
            scheduledDateTime: this.state.scheduledDateInput
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          this.setState({ 
            scheduledAwardDate: this.state.scheduledDateInput,
            uploading: false 
          });
          console.log('Award delivery scheduled successfully');
        } else {
          console.error('Failed to schedule award delivery:', data.message);
          this.setState({ uploading: false });
        }
      } catch (error) {
        console.error('Error scheduling award delivery:', error);
        this.setState({ uploading: false });
      }
    }
  };

  handleCancelSchedule = async () => {
    try {
      this.setState({ uploading: true });
      
      const response = await fetch('https://www.hkarbsoc.org.hk:9000/removeScheduledAwardDelivery', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          caseId: this.props.caseId
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        this.setState({ 
          scheduledAwardDate: null,
          scheduledDateInput: '',
          uploading: false 
        });
        console.log('Award delivery schedule cancelled successfully');
      } else {
        console.error('Failed to cancel award delivery schedule:', data.message);
        this.setState({ uploading: false });
      }
    } catch (error) {
      console.error('Error cancelling award delivery schedule:', error);
      this.setState({ uploading: false });
    }
  };

  handleScheduleAIGen = async () => {
    if (this.state.scheduledAIGenInput) {
      try {
        this.setState({ uploading: true });
        
        const response = await fetch('https://www.hkarbsoc.org.hk:9000/scheduleAwardAIGeneration', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            caseId: this.props.caseId,
            scheduledAIGenDateTime: this.state.scheduledAIGenInput
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          this.setState({ 
            scheduledAIGenDate: this.state.scheduledAIGenInput,
            uploading: false 
          });
          console.log('AI award generation scheduled successfully');
        } else {
          console.error('Failed to schedule AI award generation:', data.message);
          this.setState({ uploading: false });
        }
      } catch (error) {
        console.error('Error scheduling AI award generation:', error);
        this.setState({ uploading: false });
      }
    }
  };

  handleCancelAIGenSchedule = async () => {
    try {
      this.setState({ uploading: true });
      
      const response = await fetch('https://www.hkarbsoc.org.hk:9000/removeAwardAIGeneration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          caseId: this.props.caseId
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        this.setState({ 
          scheduledAIGenDate: null,
          scheduledAIGenInput: '',
          uploading: false 
        });
        console.log('AI award generation schedule cancelled successfully');
      } else {
        console.error('Failed to cancel AI award generation schedule:', data.message);
        this.setState({ uploading: false });
      }
    } catch (error) {
      console.error('Error cancelling AI award generation schedule:', error);
      this.setState({ uploading: false });
    }
  };

  handleScheduleNoticeAIGen = async () => {
    if (this.state.scheduledNoticeAIGenInput) {
      try {
        this.setState({ uploading: true });
        
        const response = await fetch('https://www.hkarbsoc.org.hk:9000/scheduleNoticeAIGeneration', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            caseId: this.props.caseId,
            scheduledNoticeAIGenDateTime: this.state.scheduledNoticeAIGenInput
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          this.setState({ 
            scheduledNoticeAIGenDate: this.state.scheduledNoticeAIGenInput,
            uploading: false 
          });
          console.log('Arbitration notice AI generation scheduled successfully');
        } else {
          console.error('Failed to schedule arbitration notice AI generation:', data.message);
          this.setState({ uploading: false });
        }
      } catch (error) {
        console.error('Error scheduling arbitration notice AI generation:', error);
        this.setState({ uploading: false });
      }
    }
  };

  handleCancelNoticeAIGenSchedule = async () => {
    try {
      this.setState({ uploading: true });
      
      const response = await fetch('https://www.hkarbsoc.org.hk:9000/removeNoticeAIGeneration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          caseId: this.props.caseId
        })
      });
      
      const data = await response.json();
      
      if (data.success) {
        this.setState({ 
          scheduledNoticeAIGenDate: null,
          scheduledNoticeAIGenInput: '',
          uploading: false 
        });
        console.log('Arbitration notice AI generation schedule cancelled successfully');
      } else {
        console.error('Failed to cancel arbitration notice AI generation schedule:', data.message);
        this.setState({ uploading: false });
      }
    } catch (error) {
      console.error('Error cancelling arbitration notice AI generation schedule:', error);
      this.setState({ uploading: false });
    }
  };

  render() {
    const { classes, isLoading, arbitrators } = this.props;
    return (
      <div //onSubmit={this.submitHandler}
      //  style={{marginTop:50}} 
       >
        <div style={{ textAlign: "center" }} className={classes.root}>
          <Grid
            container
            spacing={8}
            alignItems="center"
            direction="column"
            justify="center"
          >
            <table>
              <th>
                <UploadDocSingleFile
                  //doc_name={null}
                  //file={null}
                  reset={this.state.reset}
                  toggleReset={this.toggleReset}
                  key={0}
                  fileNumber={0 + 1}
                  onAddIconClick={this.handleOnAddIcon}
                  onAddFile={this.handleAddFile}
                  onResetFile={this.handleResetFile}
                  file={this.props.files[0]}
                />
              </th>
              <th>
                {!this.state.uploading && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={()=>{this.submitHandler()}}
                    disabled={this.state.uploading}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("Upload")}
                  </Button>
                )}
                {this.state.uploading && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={this.state.uploading}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("uploading")}
                  </Button>
                )}
                {/* {this.state.uploading && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )} */}
              </th>
              {/* <th>
                {!this.state.uploadingFullPdf && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={()=>{this.submitHandlerUploadFullPdf()}}
                    disabled={this.state.uploadingFullPdf}
                    style={{
                      height: "30px",
                      width: "185px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("Upload Full PDF")}
                  </Button>
                )}
                {this.state.uploadingFullPdf && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={this.state.uploadingFullPdf}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("uploading")}
                  </Button>
                )}
                {this.state.uploading && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )}
                {this.state.uploadingFullPdf && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )}
              </th> */}
            </table>
          </Grid>
          <Typography style={{ marginTop: "10px", textAlign: "center" }}>
            {this.context.t(
              "Please upload word (.docx) file and it will be converted to PDF automatically."
            )}
          </Typography>

          {/* Scheduled Award Delivery Date - Only for Admin and Arbitrator */}
          {(this.state.typeOfAccount === "admin" || this.state.typeOfAccount === "arbitrator") && (this.props.caseData.awardDelivered == 'waiting' || this.props.caseData.awardDelivered == undefined || this.props.caseData.awardDelivered == false) && (
            <div style={{ marginTop: "30px", textAlign: "center" }}>
              <FormControl className={classes.formControl}>
                <Typography style={{ marginBottom: "10px" }}>
                  {this.context.t("Scheduled Award Delivery Date")}
                </Typography>
                <Input
                  type="datetime-local"
                  value={this.state.scheduledDateInput}
                  onChange={this.handleScheduledDateChange}
                  style={{ marginBottom: "10px", width: "300px", fontSize: "16px" }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleScheduleAwardDate}
                  disabled={!this.state.scheduledDateInput}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {this.context.t("Schedule")}
                </Button>
                {this.state.scheduledAwardDate && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleCancelSchedule}
                    disabled={this.state.uploading}
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    {this.context.t("Cancel Schedule")}
                  </Button>
                )}
              </FormControl>
              {this.state.scheduledAwardDate && (this.props.caseData.awardDelivered == 'waiting' || this.props.caseData.awardDelivered == undefined || this.props.caseData.awardDelivered == false) && (
                <Typography style={{ marginTop: "15px", color: "#1976d2", fontWeight: "900" }}>
                  {this.context.t("The scheduled award delivery is on")} {new Date(this.state.scheduledAwardDate).toLocaleString()}
                </Typography>
              )}
            </div>
          )}

          {/* Scheduled AI Award Generation - Only for Admin and Arbitrator */}
          {(this.state.typeOfAccount === "admin" || this.state.typeOfAccount === "arbitrator") && (
            <div style={{ marginTop: "30px", textAlign: "center", borderTop: "1px solid #ccc", paddingTop: "20px" }}>
              <FormControl className={classes.formControl}>
                <Typography style={{ marginBottom: "10px", fontWeight: "bold" }}>
                  {this.context.t("Scheduled AI Award Generation Date")}
                </Typography>
                <Input
                  type="datetime-local"
                  value={this.state.scheduledAIGenInput}
                  onChange={this.handleScheduledAIGenChange}
                  style={{ marginBottom: "10px", width: "300px", fontSize: "16px" }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.handleScheduleAIGen}
                  disabled={!this.state.scheduledAIGenInput}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {this.context.t("Schedule AI Generation")}
                </Button>
                {this.state.scheduledAIGenDate && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={this.handleCancelAIGenSchedule}
                    disabled={this.state.uploading}
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    {this.context.t("Cancel AI Generation Schedule")}
                  </Button>
                )}
              </FormControl>
              {this.state.scheduledAIGenDate && (
                <Typography style={{ marginTop: "15px", color: "#d32f2f", fontWeight: "900" }}>
                  {this.context.t("The scheduled AI award generation is on")} {new Date(this.state.scheduledAIGenDate).toLocaleString()}
                </Typography>
              )}
            </div>
          )}

          {/* Scheduled AI Notice Generation - Only for Admin and Arbitrator */}
          {/* {(this.state.typeOfAccount === "admin" || this.state.typeOfAccount === "arbitrator") && (
            <div style={{ marginTop: "30px", textAlign: "center", borderTop: "1px solid #ccc", paddingTop: "20px" }}>
              <FormControl className={classes.formControl}>
                <Typography style={{ marginBottom: "10px", fontWeight: "bold" }}>
                  {this.context.t("Scheduled AI Arbitration Notice Generation Date")}
                </Typography>
                <Input
                  type="datetime-local"
                  value={this.state.scheduledNoticeAIGenInput}
                  onChange={this.handleScheduledNoticeAIGenChange}
                  style={{ marginBottom: "10px", width: "300px", fontSize: "16px" }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.handleScheduleNoticeAIGen}
                  disabled={!this.state.scheduledNoticeAIGenInput}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {this.context.t("Schedule Notice AI Generation")}
                </Button>
                {this.state.scheduledNoticeAIGenDate && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={this.handleCancelNoticeAIGenSchedule}
                    disabled={this.state.uploading}
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    {this.context.t("Cancel Notice AI Generation Schedule")}
                  </Button>
                )}
              </FormControl>
              {this.state.scheduledNoticeAIGenDate && (
                <Typography style={{ marginTop: "15px", color: "#ff6f00", fontWeight: "900" }}>
                  {this.context.t("The scheduled AI arbitration notice generation is on")} {new Date(this.state.scheduledNoticeAIGenDate).toLocaleString()}
                </Typography>
              )}
            </div>
          )} */}
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.uploadDocs.loading,
    files: state.uploadDocs.files,
    userType: state.caseInfo.userType,
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
    removeFile: (filename) => dispatch(actions.removeFile(filename)),
    uploadDocs: (files, conversationId, caseId, userType, doc_type) =>
      dispatch(actions.uploadWordDoc(files, conversationId, caseId, userType, doc_type)),
    uploadFullPDFDoc: (files, conversationId, caseId, userType, doc_type) =>
      dispatch(actions.uploadFullPDFDoc(files, conversationId, caseId, userType, doc_type)),
  };
};

UploadDocsSingleFile.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UploadDocsSingleFile)));
